import { memo } from "react"
import { makeStyles } from "tss-react/mui"
import { ApiQueryAutocomplete } from "../../../../../../core/api/components/ApiQueryAutocomplete"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"

import {
    CreateOrderOnBehalfOfQuery,
    fetchOrderOnBehalfOfCompaniesForServiceCenter,
    OrderOnBehalfOfCompaniesResponse,
} from "../../../../../../shared/components/createOrder/orderOnBehalf/orderOnBehalfFlowApi"
import { useAppSelector } from "../../../../../store/storeHooks"
import { selectServiceCenterId } from "../../../../../login/loginSelectors"
import { AccountingCustomer } from "../../../../../merchant/accounting/accounting/accountingApi"

const useStyles = makeStyles()((_theme) => ({
    input: {
        width: "22rem",
        backgroundColor: "white",
    },
}))

const selectCustomers = (data: OrderOnBehalfOfCompaniesResponse) => data?.customers || []

type CompaniesSelectorProps = Readonly<{
    companyItem: AccountingCustomer | null
    handleChange: (el: AccountingCustomer | null) => void
}>

export const CompaniesSelector = memo(({ companyItem, handleChange }: CompaniesSelectorProps) => {
    const { classes } = useStyles()
    const serviceCenterId = useAppSelector(selectServiceCenterId)

    const {
        data: companies = [],
        isLoading,
        isError,
    } = useApiQuery(fetchOrderOnBehalfOfCompaniesForServiceCenter, {
        queryName: CreateOrderOnBehalfOfQuery.COMPANIES_SERVICE_CENTER,
        dependencies: {
            serviceCenterId: serviceCenterId ?? 0,
        },
        select: selectCustomers,
    })

    return (
        <>
            <LocalizedStrict
                id="service-center-reports-statistic-customer-usage-filter-customer-label"
                attrs={{ label: true }}
            >
                <ApiQueryAutocomplete
                    isLoading={isLoading}
                    isError={isError}
                    options={companies}
                    value={companyItem}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    onChange={(event, value) => handleChange(value)}
                    label="Customer"
                    slotProps={{
                        textField: { className: classes.input },
                        errorSelect: { className: classes.input },
                    }}
                />
            </LocalizedStrict>
        </>
    )
})
